import { defineMessages } from 'react-intl';
import heroSVG from '@plone/volto/icons/hero.svg';
import View from './View';
import Edit from './Edit';
import { isContentType, findBlockById } from '@package/helpers/blockConditions';

defineMessages({
  heroImage: {
    id: 'Hero image',
    defaultMessage: 'Hero image',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.heroImage = {
    id: 'heroImage',
    title: 'Hero image',
    group: 'layout',
    icon: heroSVG,
    view: View,
    edit: Edit,
    restricted: ({ properties, block }) => {
      return (
        !isContentType(properties, 'LRF') || findBlockById(properties, block)
      );
    },
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
